import { useEffect, useState, createContext } from 'react';
import auth from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

export const Context = createContext();

export function AuthContext({ children }) {
  const [authLoading, setAuthLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    let unsubscribe;
    unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
      setAuthLoading(false);
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const values = {
    user,
    authLoading,
  };

  return <Context.Provider value={values}>{children}</Context.Provider>;
}
